import { trpc } from '../../config/trpc';

export const useApiKeys = (accountId?: number) => {
  const utils = trpc.useUtils();
  const input = { account_id: accountId as number };
  const invalidateApiKeys = () => utils.getApiKeysByAccount.invalidate(input);

  const { data: apiKeys, isLoading } = trpc.getApiKeysByAccount.useQuery(input, { enabled: !!accountId });

  const {
    mutateAsync: createApiKey,
    isLoading: isCreating,
    reset: resetCreateApiKey,
  } = trpc.createApiKey.useMutation({ cacheTime: 0 });
  const { mutateAsync: revokeApiKey, isLoading: isRevoking } = trpc.revokeApiKey.useMutation({
    onSuccess: invalidateApiKeys,
  });

  return {
    apiKeys,
    isLoading,
    createApiKey,
    revokeApiKey,
    isCreating,
    isRevoking,
    resetCreateApiKey,
    invalidateApiKeys,
  };
};
